import { useRef, useState } from "react";
import { sharePost } from "../../functions/post";
import useClickOutside from "../../helpers/clickOutside";
import PulseLoader from "react-spinners/PulseLoader";

export default function ShareMenu({
  postId,
  user,
  setShowShareMenu,
  setSharesCount,
  onShare,
}) {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const menuRef = useRef(null);

  useClickOutside(menuRef, () => {
    setShowShareMenu(false);
  });

  const handleShare = async (shareType) => {
    if (shareType === "now") {
      setLoading(true);
      const res = await sharePost(postId, "", user.token);
      setLoading(false);
      if (res.status === "ok") {
        setSharesCount((prev) => prev + 1);
        if (onShare) onShare(res.data);
        setShowShareMenu(false);
      }
    }
  };

  const handleShareWithText = async () => {
    setLoading(true);
    const res = await sharePost(postId, text, user.token);
    setLoading(false);
    if (res.status === "ok") {
      setSharesCount((prev) => prev + 1);
      if (onShare) onShare(res.data);
      setShowShareMenu(false);
      setText("");
    }
  };

  return (
    <div className="share_menu" ref={menuRef}>
      <div className="share_menu_header">Share Post</div>
      <div className="share_menu_content">
        <div className="share_option hover1" onClick={() => handleShare("now")}>
          <i className="share_icon"></i>
          <div className="share_option_text">
            <span className="share_option_title">Share Now</span>
            <span className="share_option_desc">Instantly share to your feed</span>
          </div>
        </div>
        <div className="share_divider"></div>
        <div className="share_with_text">
          <div className="share_input_wrapper">
            <img src={user.picture} alt="" className="share_user_img" />
            <textarea
              placeholder="Write something..."
              value={text}
              onChange={(e) => setText(e.target.value)}
              className="share_input"
            ></textarea>
          </div>
          <button
            className="share_button"
            onClick={handleShareWithText}
            disabled={loading}
          >
            {loading ? <PulseLoader color="#fff" size={5} /> : "Share"}
          </button>
        </div>
      </div>
    </div>
  );
}
